<template>
  <div id="app">
    <loading-component/>
    <file-loading-component/>
    <div v-if="$route.meta.hideNavigation">
      <Login></Login>
    </div>
    <div v-else>
      <AsideMain />
      <div class="app">
        <div class="b-main">
          <AppHeader />
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "./components/header/Header";
import AsideMain from "./components/aside/Aside";
import Login from "./components/Login";

export default {
  components: {
    AppHeader,
    AsideMain,
    Login
  },
  created() {
    if (window.ENV.IDENTITY_SERVER_URL === "") {
      console.warn(`${this.$t("NOTIFY.not_found_config")} IDENTITY_SERVER_URL`);
    }
    if (window.ENV.WEB_API_URL === "") {
      console.warn(`${this.$t("NOTIFY.not_found_config")} WEB_API_URL`);
    }
  }
};
</script>
